import { Tab as MuiTab, Grid, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SPACING } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const Container = styled(Grid)({
  display: "flex",
  gap: "15px",
  width: "100%",
  flexDirection: "column",
  // marginBottom:"20px"
});

export const StyledTabs = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== "isExtension" && prop !== "maxDisplayedTabs",
})<{ isExtension: boolean; maxDisplayedTabs?: number }>(
  {
    marginTop: `${SPACING[3]}`,
    minHeight: "28px",
    "& .MuiTabs-flexContainer": {
      gap: "15px",
      alignItems: "flex-start",
    },
  },

  ({ isExtension, maxDisplayedTabs }) => ({
    ...(!isExtension &&
      maxDisplayedTabs && {
        [`& .MuiTab-root:nth-of-type(n+${maxDisplayedTabs + 1})`]: {
          display: "none",
        },
      }),
    ...(isExtension &&
      maxDisplayedTabs && {
        [`& .MuiTab-root:not(:nth-of-type(n+${maxDisplayedTabs + 1}))`]: {
          display: "none",
        },
      }),
  })
);

export const Tab = styled(MuiTab)(({ theme }) => ({
  textTransform: "none",

  "&.MuiTab-root": {
    fontSize: `${theme.typography.h6.fontSize}px`,
    alignItems: "flex-start",
    padding: `0px ${SPACING[9]}px 0px 0px`,
    minHeight: "unset",
    color: theme.palette.text.disabled,
    // backgroundColor:"transparent",
    fontWeight: "400",
    // display:"inline",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: "15px",

    "&.Mui-selected": {
      color: theme.palette.primary.main,
      fontWeight: "500",
    },
  },
  "& .MuiTab-wrapper": {
    height: "100%",
    display: "flex",
    // flexDirection: "row",
    alignItems: "flex-start",
  },
}));
